import { Logger } from '../../shared/logger/logger';
import { ConfigureGalleryServiceProxy, VirtualDeviceVideoServiceProxy, VirtualDeviceWeatherServiceProxy } from '../../shared/service-proxies/service-proxies';
import { GraphService } from '../../shared/gallery/graph.service';
import { DefaultSimulateRemoteGraphProtocol } from '../../shared/gui/config/default-simulate-graph-protocol';
import { DefaultSimulateRemoteImageProtocol } from '../../shared/gui/config/default-simulate-image-protocol';
import { DefaultSimulateRemoteViewProtocol } from '../../shared/gui/config/default-simulate-remote-view-protocol';
import { SimulateRemotePermissionChecker } from '../../shared/gui/simulate-remote-permission-checker';
import { RemoteGraphStore, RemoteImageStore, RemoteVariableCommunicator, RemoteViewStore } from '@flexem/fc-gui';
import { SimulateHistoryDataStore } from './simulate-history-data.store';
import { SimulateRemoteOperationRecordService } from './simulate-remote-operation-record.service';
import { SimulateRemoteSecurityChecker } from './simulate-remote-security-checker';
import { SimulateRemoteVideoService } from './simulate-remote-video.service';
import { SimulateVariableStore } from './simulate-variable.store';
import { SimulateRemoteWeatherService } from './simulate-remote-weather.service';
import { DefaultSimulateRemoteVariableProtocol } from './default-simulate-variable-protocol';
import { StringifyingMap } from '../utils/stringifying-map';
var SimulateRemoteGuiContext = /** @class */ (function () {
    function SimulateRemoteGuiContext(injector, args) {
        this.injector = injector;
        if (!args) {
            return;
        }
        var graphService = injector.get(GraphService);
        this.logger = injector.get(Logger);
        this.virtualDeviceVideoService = injector.get(VirtualDeviceVideoServiceProxy);
        this.virtualDeviceWeatherService = injector.get(VirtualDeviceWeatherServiceProxy);
        var configureGalleryService = injector.get(ConfigureGalleryServiceProxy);
        var viewStore = new RemoteViewStore(new DefaultSimulateRemoteViewProtocol(args.views, args.mainViewIndex));
        var graphStore = new RemoteGraphStore(new DefaultSimulateRemoteGraphProtocol(graphService, configureGalleryService));
        var imageStore = new RemoteImageStore(new DefaultSimulateRemoteImageProtocol());
        var historyDataStore = new SimulateHistoryDataStore();
        var variableStore = new SimulateVariableStore(args.variables);
        this.configStore = {
            viewStore: viewStore, graphStore: graphStore, imageStore: imageStore, historyDataStore: historyDataStore, variableStore: variableStore
        };
        this.variableValueStore = new StringifyingMap(function (k) { return JSON.stringify(k); });
        this.variables = args.variables;
        this.variableCommunicator = new RemoteVariableCommunicator(new DefaultSimulateRemoteVariableProtocol(this.variableValueStore, this.variables), this.logger);
        this.permissionChecker = new SimulateRemotePermissionChecker(args.ownedPermissions);
        this.operationRecordService = new SimulateRemoteOperationRecordService();
        this.securityChecker = new SimulateRemoteSecurityChecker();
        this.videoService = new SimulateRemoteVideoService(this.virtualDeviceVideoService);
        this.weatherService = new SimulateRemoteWeatherService(this.virtualDeviceWeatherService);
    }
    SimulateRemoteGuiContext.prototype.replace = function (views, mainViewIndex, permissios) {
        var result = new SimulateRemoteGuiContext();
        var viewStore = new RemoteViewStore(new DefaultSimulateRemoteViewProtocol(views, mainViewIndex));
        var configStore = {
            viewStore: viewStore, graphStore: this.configStore.graphStore, imageStore: this.configStore.imageStore,
            historyDataStore: this.configStore.historyDataStore, variableStore: this.configStore.variableStore
        };
        result.configStore = configStore;
        result.variableValueStore = this.variableValueStore;
        result.variableCommunicator = new RemoteVariableCommunicator(new DefaultSimulateRemoteVariableProtocol(this.variableValueStore, this.variables), this.logger);
        result.permissionChecker = new SimulateRemotePermissionChecker(permissios);
        result.operationRecordService = new SimulateRemoteOperationRecordService();
        result.securityChecker = new SimulateRemoteSecurityChecker();
        result.videoService = new SimulateRemoteVideoService(this.injector.get(VirtualDeviceVideoServiceProxy));
        result.weatherService = new SimulateRemoteWeatherService(this.injector.get(VirtualDeviceWeatherServiceProxy));
        result.injector = this.injector;
        return result;
    };
    SimulateRemoteGuiContext.prototype.dispose = function () {
        if (this.variableCommunicator) {
            this.variableCommunicator.dispose();
        }
    };
    return SimulateRemoteGuiContext;
}());
export { SimulateRemoteGuiContext };
